var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormItem',{attrs:{"label":"和其他实验：","prop":"experimentType","rules":[
      {
        required: true,
        message: '请选择和其他实验的关系',
        trigger: 'change'
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid"},model:{value:(_vm.formData.experimentType),callback:function ($$v) {_vm.$set(_vm.formData, "experimentType", $$v)},expression:"formData.experimentType"}},[_c('Radio',{attrs:{"label":"0","disabled":_vm.readonly}},[_vm._v("互斥")]),_c('Radio',{attrs:{"label":"1","disabled":_vm.readonly}},[_vm._v("并行")])],1)],1)],1),_c('FormItem',{attrs:{"label":"操作系统：","prop":"deviceSys","rules":[
      { required: true, message: '请选择操作系统', trigger: 'change' }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid"},model:{value:(_vm.formData.deviceSys),callback:function ($$v) {_vm.$set(_vm.formData, "deviceSys", $$v)},expression:"formData.deviceSys"}},[_c('Radio',{attrs:{"label":"-1","disabled":_vm.readonly}},[_vm._v("不限")]),_c('Radio',{attrs:{"label":"0","disabled":_vm.readonly}},[_vm._v("IOS")]),_c('Radio',{attrs:{"label":"1","disabled":_vm.readonly}},[_vm._v("安卓")])],1)],1)],1),_c('FormItem',{attrs:{"label":"推广渠道：","prop":"linkChannel","rules":[
      {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          callback()
        }
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('div',{staticStyle:{"display":"flex"}},[_c('Checkbox',{attrs:{"border":"","value":!_vm.formData.linkChannel || !_vm.formData.linkChannel.length,"disabled":_vm.readonly},on:{"on-change":(checked) => {
              if (checked) {
                _vm.formData.linkChannel = []
              }
            }}},[_vm._v("\n          不限\n        ")]),_c('CheckboxGroup',{attrs:{"type":"button","disabled":_vm.readonly},model:{value:(_vm.formData.linkChannel),callback:function ($$v) {_vm.$set(_vm.formData, "linkChannel", $$v)},expression:"formData.linkChannel"}},[_c('Checkbox',{attrs:{"label":"0","disabled":_vm.readonly,"border":""}},[_vm._v("Meta")]),_c('Checkbox',{attrs:{"label":"1","disabled":_vm.readonly,"border":""}},[_vm._v("TikTok")]),_c('Checkbox',{attrs:{"label":"2","disabled":_vm.readonly,"border":""}},[_vm._v("Google")])],1)],1)])],1),_c('FormItem',{attrs:{"label":"国家范围：","prop":"countriesUnlimited","required":"","rules":[
      {
        message: '请选择国家范围',
        trigger: 'change',
        validator(rule, value, callback) {
          if (
            _vm.formData.countriesUnlimited !== 0 &&
            _vm.formData.countriesUnlimited !== 1
          ) {
            callback('请选择国家范围')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","disabled":_vm.readonly,"button-style":"solid"},on:{"on-change":function($event){_vm.formData.countries = []}},model:{value:(_vm.formData.countriesUnlimited),callback:function ($$v) {_vm.$set(_vm.formData, "countriesUnlimited", $$v)},expression:"formData.countriesUnlimited"}},[_c('Radio',{attrs:{"label":0,"disabled":_vm.readonly}},[_vm._v("不限")]),_c('Radio',{attrs:{"label":1,"disabled":_vm.readonly}},[_vm._v("指定国家")])],1)],1)],1),(_vm.formData.countriesUnlimited)?_c('FormItem',{attrs:{"prop":"countries","rules":[
      {
        message: '请选择国家',
        trigger: 'change',
        validator(rule, value, callback) {
          if (!_vm.formData.countries || _vm.formData.countries.length === 0) {
            callback('请选择国家')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('MultiCascader',{staticStyle:{"width":"300px"},attrs:{"disabled":_vm.readonly,"data":_vm.countryLi},model:{value:(_vm.formData.countries),callback:function ($$v) {_vm.$set(_vm.formData, "countries", $$v)},expression:"formData.countries"}})],1)],1):_vm._e(),_c('FormItem',{attrs:{"label":"注册剧目：","prop":"playIdsUnlimited","rules":[
      {
        required: true,
        message: '请选择注册剧目',
        trigger: 'change',
        validator(rule, value, callback) {
          if (
            _vm.formData.playIdsUnlimited !== 0 &&
            _vm.formData.playIdsUnlimited !== 1
          ) {
            callback('请选择注册剧目')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('Tooltip',{attrs:{"disabled":!_vm.readonly,"content":`如需修改,请先点击'返回上一步'`}},[_c('RadioGroup',{attrs:{"type":"button","button-style":"solid","disabled":_vm.readonly},on:{"on-change":() => {
            _vm.formData.playIds = []
            _vm.handleGetPlayBatch()
          }},model:{value:(_vm.formData.playIdsUnlimited),callback:function ($$v) {_vm.$set(_vm.formData, "playIdsUnlimited", $$v)},expression:"formData.playIdsUnlimited"}},[_c('Radio',{attrs:{"label":0,"disabled":_vm.readonly}},[_vm._v("不限")]),_c('Radio',{attrs:{"label":1,"disabled":_vm.readonly}},[_vm._v("指定项目")])],1)],1)],1),(_vm.formData.playIdsUnlimited)?_c('FormItem',{attrs:{"prop":"playIds","rules":[
      {
        message: '请选择注册剧目',
        trigger: 'change',
        validator(rule, value, callback) {
          if (!_vm.formData.playIds || _vm.formData.playIds.length === 0) {
            callback('请选择注册剧目')
          } else {
            callback()
          }
        }
      }
    ]}},[_c('playCascader',{ref:"playCnRef",staticStyle:{"width":"300px"},attrs:{"disabled":_vm.readonly,"value":_vm.formData.playIds},on:{"update:value":function($event){_vm.formData.playIds = $event}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }